var map = {
	"./BICC-directions.pdf": "9926",
	"./HiC.png": "cbb1",
	"./HiC_thumb.png": "a321",
	"./Iseli_Christian.jpg": "4af2",
	"./bicc_chris.png": "ec46",
	"./bicc_jumbotron.png": "06f5",
	"./bicc_nguex.png": "a2d6",
	"./bicc_unil.png": "938c",
	"./bicc_xmas.png": "9a18",
	"./bicc_xmas_2020.png": "0954",
	"./bicc_xmas_2022.png": "02d1",
	"./cellProximity.png": "f99a",
	"./cellProximity_thumb.png": "3435",
	"./directions.png": "a66e",
	"./eeg.png": "263a",
	"./eeg_thumb.png": "ab6e",
	"./epfllogo.png": "7c1a",
	"./epfllogo_small.png": "0872",
	"./epigeneticMarks.png": "cf97",
	"./epigeneticMarks_thumb.png": "1de4",
	"./facs.png": "7dcc",
	"./facs_thumb.png": "42cb",
	"./icon-genomics.png": "a8bf",
	"./imagePathology.png": "bb89",
	"./imagePathology_thumb.png": "583a",
	"./img_NG.jpg": "3f16",
	"./jumbotron_bgd.png": "6d33",
	"./metagenomics.png": "9029",
	"./metagenomics_thumb.png": "a8e6",
	"./napoleome.png": "011c",
	"./napoleome_thumb.png": "fbcd",
	"./ngs.png": "1c10",
	"./ngs_thumb.png": "0306",
	"./office2030.png": "57f7",
	"./prendia.png": "c90d",
	"./prendia_thumb.png": "d2b6",
	"./projectExamples": "6520",
	"./projectExamples.json": "6520",
	"./proteinStructure.png": "ece4",
	"./proteinStructure_thumb.png": "cc5d",
	"./rnaseq.png": "1e70",
	"./rnaseq_thumb.png": "6356",
	"./transcriptionFactors.png": "c9a4",
	"./transcriptionFactors_thumb.png": "b149",
	"./unilogo.png": "dad7",
	"./unilogo_small.png": "4352",
	"./vibrio.png": "03a1",
	"./vibrio_thumb.png": "aae6",
	"./virus.png": "1f72",
	"./virus_thumb.png": "6343",
	"./webBxd.png": "1181",
	"./webBxd_thumb.png": "30dd",
	"./webInfused.png": "7b06",
	"./webInfused_thumb.png": "2359"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";